import { dimensions, SvgIconProps } from "./SvgIcon";
import { theme } from "antd";

export const SlackIcon = (props: SvgIconProps) => {
  const { token } = theme.useToken();
  const { width, height } = dimensions(props);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2501 6.49979C12.9404 6.49979 13.5 5.94019 13.5 5.24989C13.5 4.5596 12.9404 4 12.2501 4C11.5597 4 11 4.55964 11 5.25V6.49979H12.2501ZM8.75 6.49979C9.44036 6.49979 10 5.94014 10 5.24979V1.75C10 1.05964 9.44036 0.5 8.75 0.5C8.05964 0.5 7.5 1.05964 7.5 1.75V5.24979C7.5 5.94014 8.05964 6.49979 8.75 6.49979Z"
        fill={token.colorSuccess}
      />
      <path
        d="M1.74989 7.50021C1.0596 7.50021 0.5 8.05981 0.5 8.75011C0.5 9.4404 1.05965 10 1.74995 10C2.4403 10 3 9.44035 3 8.75V7.50021H1.74989ZM5.25 7.50021C4.55964 7.50021 4 8.05986 4 8.75021V12.25C4 12.9404 4.55964 13.5 5.25 13.5C5.94036 13.5 6.5 12.9404 6.5 12.25V8.75021C6.5 8.05986 5.94036 7.50021 5.25 7.50021Z"
        fill={token.colorError}
      />
      <path
        d="M7.50021 12.2501C7.50021 12.9404 8.05981 13.5 8.75011 13.5C9.4404 13.5 10 12.9403 10 12.2501C10 11.5597 9.44035 11 8.75 11L7.50021 11L7.50021 12.2501ZM7.50021 8.75C7.50021 9.44036 8.05986 10 8.75021 10L12.25 10C12.9404 10 13.5 9.44036 13.5 8.75C13.5 8.05964 12.9404 7.5 12.25 7.5L8.75021 7.5C8.05986 7.5 7.50021 8.05964 7.50021 8.75Z"
        fill={token.colorWarning}
      />
      <path
        d="M6.49979 1.74989C6.49979 1.0596 5.94019 0.5 5.24989 0.5C4.5596 0.5 4 1.05965 4 1.74995C4 2.4403 4.55965 3 5.25 3L6.49979 3L6.49979 1.74989ZM6.49979 5.25C6.49979 4.55964 5.94014 4 5.24979 4L1.75 4C1.05964 4 0.5 4.55964 0.5 5.25C0.5 5.94036 1.05964 6.5 1.75 6.5L5.24979 6.5C5.94014 6.5 6.49979 5.94036 6.49979 5.25Z"
        fill={token.colorInfo}
      />
    </svg>
  );
};
